import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

function Home() {
  const { t } = useApp();

  return (
    <div className="min-h-screen flex flex-col justify-center items-center px-4">
      <div className="text-center">
        <h1 className="text-5xl md:text-6xl font-bold title-gradient mb-6">
          {t('home.greeting')}
        </h1>
        <p className="text-xl md:text-2xl card-text mb-12">
          {t('home.subtitle')}
        </p>
        <div className="flex flex-col md:flex-row gap-4 justify-center">
          <Link
            to="/projects"
            className="glass-effect px-8 py-3 rounded-lg text-text-light dark:text-text-dark hover:bg-primary-light/10 dark:hover:bg-primary-dark/10 transition-all duration-300"
          >
            {t('home.cta.projects')}
          </Link>
          <Link
            to="/about"
            className="glass-effect px-8 py-3 rounded-lg text-text-light dark:text-text-dark hover:bg-primary-light/10 dark:hover:bg-primary-dark/10 transition-all duration-300"
          >
            {t('home.cta.about')}
          </Link>
        </div>
        <div className="pt-12 flex justify-center space-x-6">
          <a
            href="https://github.com/devthz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#94a3b8] hover:text-[#818cf8] transition-colors duration-200"
          >
            <svg className="w-20 h-20" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
          </a>
          <a
            href="https://linkedin.com/in/thiagohsa22"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#94a3b8] hover:text-[#818cf8] transition-colors duration-200"
          >
            <svg className="w-20 h-20" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-.88-.016-2.005-1.22-2.005-1.22 0-1.405.953-1.405 1.94v5.669h-3v-11h2.84v1.58h.04c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.865z"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home; 